import React from 'react';
import './styles.css';

const ProgressBar = ({ percentage }) => (
  <div className="progress-bar">
    <div
      className="progress"
      style={{
        width: `${percentage}%`,
      }}
    />
  </div>
);

ProgressBar.propTypes = {
  percentage: React.PropTypes.number.isRequired,
};

export default ProgressBar;




// WEBPACK FOOTER //
// ./src/browser/app/components/ProgressBar/ProgressBar.js